'use client';

import { c as _c } from "react/compiler-runtime";
import useIsBrowser from 'hooks/useIsBrowser';
import React, { useEffect } from 'react';
let isHashHandlerAdded = false;

// This hook is required due to limitations of the Next.js router.
// Please see https://stackoverflow.com/a/79215367/3474617 for more information.

const useLocationHash = () => {
  const $ = _c(4);
  const isBrowser = useIsBrowser();
  const [hash, setHash] = React.useState(isBrowser ? window.location.hash : "");
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const onHashChanged = () => setHash(window.location.hash);
      window.addEventListener("hashchange", onHashChanged);
      return () => {
        window.removeEventListener("hashchange", onHashChanged);
      };
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      if (!isHashHandlerAdded) {
        isHashHandlerAdded = true;
        const {
          pushState,
          replaceState
        } = window.history;
        window.history.pushState = function (...t4) {
          const args = t4;
          pushState.apply(window.history, args);
          setTimeout(() => setHash(window.location.hash));
        };
        window.history.replaceState = function (...t5) {
          const args_0 = t5;
          replaceState.apply(window.history, args_0);
          setTimeout(() => setHash(window.location.hash));
        };
      }
    };
    t3 = [];
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  return hash;
};
export default useLocationHash;